import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

const presentations = [
  { title: 'Best of Oracle Security 2022', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2022.pdf' },
  { title: 'Best of Oracle Security 2021', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2021.pdf' },
  { title: 'Best of Oracle Security 2020', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2020.pdf' },
  { title: 'Best of Oracle Security 2019', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2019.pdf' },
  { title: 'Best of Oracle Security 2018', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2018.pdf' },
  { title: 'Best of Oracle Security 2017', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2017.pdf' },
  { title: 'Best of Oracle Security 2016', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2016.pdf' },
  { title: 'Best of Oracle Security 2015', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2015.pdf' },
  { title: 'Best of Oracle Security 2014', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2014.pdf' },
  { title: 'Best of Oracle Security 2013', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2013.pdf' },
  { title: 'Best of Oracle Security 2012', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2012.pdf' },
  { title: 'Best of Oracle Security 2011', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2011.pdf' },
  { title: 'Best of Oracle Security 2010', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2010.pdf' },
  { title: 'Best of Oracle Security 2009', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2009.pdf' },
  { title: 'Best of Oracle Security 2008', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2008.pdf' },
  { title: 'Best of Oracle Security 2007', url: 'https://www.red-database-security.com/wp/best_of_oracle_security_2007.pdf' },
];

const whitepapers = [
  { title: 'Secure PL/SQL', url: 'https://www.red-database-security.com/wp/secure_plsql_v3.pdf' },
  { title: 'MD5 Password Hashes in Oracle 12c', url: 'https://www.red-database-security.com/wp/m5_password_hashes_in_oracle_12c.pdf' },
  { title: 'Oracle Rootkits 2.0', url: 'https://www.red-database-security.com/wp/oracle_rootkits_2.0.pdf' },
  { title: 'Oracle SQL Injection 2009', url: 'https://www.red-database-security.com/wp/oracle_sql_injection_2009.pdf' },
  { title: 'Unified Auditing Policies', url: 'https://www.red-database-security.com/wp/unified_auditing_policies.pdf' },
  { title: 'Roles & Privileges in Oracle', url: 'https://www.red-database-security.com/wp/roles_privileges_oracle.pdf' },
  { title: 'DEFCON - Oracle Rootkits 2.0', url: 'https://www.red-database-security.com/wp/defcon_oracle_rootkits_2.0.pdf' },
  { title: 'Oracle Forensics 101', url: 'https://www.red-database-security.com/wp/oracle_forensics_101.pdf' },
  { title: 'Google Oracle Hacking', url: 'https://www.red-database-security.com/wp/google_oracle_hacking_us.pdf' },
];

const cisBenchmarks = [
  { title: 'CIS Oracle Database 26ai', url: 'https://workbench.cisecurity.org/files/7324/download' },
  { title: 'CIS Oracle Database 23ai', url: 'https://workbench.cisecurity.org/files/6600/download' },
  { title: 'CIS Oracle Database 19c', url: 'https://workbench.cisecurity.org/files/7094/download' },
  { title: 'CIS Oracle Database 18c', url: 'https://workbench.cisecurity.org/files/4581/download' },
  { title: 'CIS Oracle Database 12c', url: 'https://workbench.cisecurity.org/files/2741/download' },
];

function Presentations() {
  const { lang } = useLanguage();

  return (
    <>
      <section className="page-hero">
        <h1><span className="gradient-text">{t(lang, 'pres_title')}</span></h1>
        <p>{t(lang, 'pres_subtitle')}</p>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">{t(lang, 'pres_cis_title')}</h2>
          <p className="section-subtitle">{t(lang, 'pres_cis_subtitle')}</p>

          <div className="cis-badges">
            <a href="https://www.credly.com/badges/77a27cc6-e5e8-46c0-806a-c9faf7396d8c" target="_blank" rel="noopener noreferrer">
              <img src="/cis2025_author.png" alt="CIS Benchmarks Community 2025 Author" className="cis-badge" />
            </a>
            <img src="/cis2024_author.png" alt="CIS Benchmarks Community 2024 Author" className="cis-badge" />
          </div>

          <div className="presentations-grid">
            {cisBenchmarks.map((item) => (
              <a
                key={item.url}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="presentation-card"
              >
                <div className="presentation-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <span className="presentation-title">{item.title}</span>
                <span className="presentation-badge">CIS</span>
              </a>
            ))}
          </div>

          <h2 className="section-title" style={{ marginTop: '4rem' }}>{t(lang, 'pres_best_title')}</h2>
          <p className="section-subtitle">{t(lang, 'pres_best_subtitle')}</p>

          <div className="presentations-grid">
            {presentations.map((item) => (
              <a
                key={item.url}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="presentation-card"
              >
                <div className="presentation-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                </div>
                <span className="presentation-title">{item.title}</span>
                <span className="presentation-badge">PDF</span>
              </a>
            ))}
          </div>

          <h2 className="section-title" style={{ marginTop: '4rem' }}>{t(lang, 'pres_wp_title')}</h2>
          <p className="section-subtitle">{t(lang, 'pres_wp_subtitle')}</p>

          <div className="presentations-grid">
            {whitepapers.map((item) => (
              <a
                key={item.url}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="presentation-card"
              >
                <div className="presentation-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                </div>
                <span className="presentation-title">{item.title}</span>
                <span className="presentation-badge">PDF</span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Presentations;
